import feathersClient, {makeServicePlugin, BaseModel} from '../../feathers-client'

class EventAgenda extends BaseModel {
    constructor(data, options) {
        super(data, options)
    }

    // Required for $FeathersVuex plugin to work after production transpile.
    static modelName = 'EventAgenda';

    // Define default properties here
    static instanceDefaults() {
        return {
            eventId: null,
            is_auto_agenda_group: false,
            agenda_type: 0,
            intro: '',
            title: '',
            order: 0,
            banner: null
        }
    }
}

const servicePath = 'f-agenda';
const servicePlugin = makeServicePlugin({
    Model: EventAgenda,
    service: feathersClient.service(servicePath),
    servicePath
});

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
    before: {
        all: [],
        find: [],
        get: [],
        create: [],
        update: [],
        patch: [],
        remove: []
    },
    after: {
        all: [],
        find: [],
        get: [],
        create: [],
        update: [],
        patch: [],
        remove: []
    },
    error: {
        all: [],
        find: [],
        get: [],
        create: [],
        update: [],
        patch: [],
        remove: []
    }
});

export default servicePlugin